<template>
    <div class="sortAndAttribute-box" >
        <div class="product-type-tabs">
            <el-tabs v-model="activeType" @tab-click="handleTypeChange">
                <el-tab-pane label="分类" name="category"></el-tab-pane>
                <el-tab-pane label="属性" name="attribute"></el-tab-pane>
            </el-tabs>
        </div>
        <!-- 按钮行 -->
        <div class="row">
            <el-button type="primary" class="create-btn" @click="create">创建</el-button>
            <div class="search-group" v-show="activeType === 'attribute'">
                <el-input placeholder="输入关键字进行过滤" v-model="attributeText" clearable=""></el-input>
                <el-button type="primary" @click="search" icon="el-icon-search">搜 索</el-button>
            </div>
        </div>
        <!-- 分类 -->
        <div v-show="activeType === 'category'" key="category" class="content">
            <div class="tree-box" v-loading="loadTree">
                <el-input
                    placeholder="输入关键字进行过滤"
                    v-model="filterText" @input="handleFilter" clearable>
                </el-input>
                <el-tree
                    class="filter-tree"
                    :data="data"
                    :props="defaultProps"
                    default-expand-all
                    highlight-current
                    :filter-node-method="filterNode"
                    @node-click="nodeClick"
                    draggable
                    :allow-drop="allowDrop"
                    @node-drop="handleDrop"
                    ref="tree">
                </el-tree>
            </div>
            <div class="table-box" v-loading="loadTable">
                <div class="table-content">
                    <el-table ref="multipleTable" :data="tableData" style="width: 100%" v-loading="load_data"
                        element-loading-text="拼命加载中" border
                        :header-cell-style="getTableHeader()" stripe>
                        <el-table-column v-for="h in tableHeader" :label="h.label" :prop="h.prop" :width="h.width" :align="h.align ? h.align : 'center'" :key="h.label">
                            <template slot-scope="scope">
                                <span v-if="h.prop === 'pid'">{{ scope.row.pid === 0 ? '-' : scope.row.text }}</span>
                                <span v-else>{{ scope.row[h.prop] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="edit(scope.row)" >编辑</el-button>
                                <el-button type="text" class="red" @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 属性 -->
        <div v-show="activeType === 'attribute'" key="attribute" class="content">
            <div class="table-box" style="width: 100%" v-loading="loadTable">
                <div class="table-content">
                    <el-table ref="multipleTable" :data="tableData" style="width: 100%" v-loading="load_data"
                        element-loading-text="拼命加载中" border
                        :header-cell-style="getTableHeader()" stripe >
                        <el-table-column v-for="h in tableHeader" :label="h.label" :prop="h.prop" :width="h.width" :align="h.align ? h.align : 'center'" :key="h.label">
                            <template slot-scope="scope">
                                <span v-if="h.prop === 'valueArray'">
                                    {{ JSON.parse(scope.row['value']).map(item => item.name).join(',') }}
                                </span>
                                <span v-else>{{scope.row[h.prop]}}</span>
                                
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                                <el-button type="text" class="red" @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
        <!-- 创建/编辑弹窗 -->
         <el-dialog :title="dialogType + (activeType === 'category' ? '分类' : '属性')" :visible.sync="createDialogVisible" width="50%" :before-close="handleClose">
            <!-- 分类 -->
            <div class="form-box" v-if="activeType === 'category'">
                <div class="form-item">
                    <div class="label">分类名称</div>
                    <div class="input-box">
                        <el-input v-model="addForm.name" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="form-item">
                    <div class="label">分类简码</div>
                    <div class="input-box">
                        <el-input v-model="addForm.code" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="form-item w100">
                    <div class="label">父级分类</div>
                    <div class="input-box">
                        <el-cascader
                            v-model="addForm.pid"
                            :options="data"
                            :props="{ value: 'id', label: 'name',checkStrictly: true }"
                            @change="handleChange" clearable>
                        </el-cascader>
                    </div>
                </div>
                <div class="form-item w100">
                    <div class="label">说明及定义</div>
                    <div class="input-box">
                        <el-input v-model="addForm.explanation" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="form-item w100">
                    <div class="label">关键属性</div>
                    <div class="input-box">
                        <el-select v-model="addForm.attributeIds" placeholder="请选择" multiple filterable >
                            <el-option :label="item.name" :value="item.id" v-for="item in attrList" :key="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <!-- 属性 -->
            <div class="form-box" v-else>
                <div class="form-item">
                    <div class="label"><span class="required">*</span>属性名称</div>
                    <div class="input-box">
                        <el-input v-model="addForm.name" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="form-item">
                    <div class="label">属性简码</div>
                    <div class="input-box">
                        <el-input v-model="addForm.code" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="form-item">
                    <div class="label"><span class="required">*</span>属性值</div>
                    <div class="input-box">
                        <div class="inputs-item" v-for="(item, index) in addForm.valueArray" :key="index">
                            <el-input v-model="item.name" placeholder="属性值名称"></el-input>
                            <el-input v-model="item.value" placeholder="属性值英文"></el-input>
                            <el-input v-model="item.code" placeholder="属性值简码"></el-input>
                            <i class="el-icon-close icon" @click="delProperty(index)"></i>
                        </div>
                        <span @click="addProperty">添加属性值</span>
                    </div>
                </div>
                <!-- <div class="form-item">
                    <div class="label">平台对于</div>
                    <div class="input-box">
                        <el-input v-model="addForm.b" placeholder="请输入"></el-input>
                    </div>
                </div> -->
            </div>
            <div slot="footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="handleCreate">{{dialogType == '创建' ? '创建' : '确定'}}</el-button>
            </div>
         </el-dialog>
        <div style="height: 20px;"></div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import common from '@/assets/js/common.js'
const { getTableHeader } = common
export default {
    name: 'sortAndAttribute',
    data() {
        return {
            deleteLoading: false,
            loadTable: false,
            loadTree: false,
            activeType: 'category',
            filterText: '',
            data: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            attributeText: '',
            addForm:{
                name: '',
                pid: [],
                code: '',
                explanation: '',
                valueArray: [],
            },
            tableData: [],
            load_data: false,
            createDialogVisible: false,
            currentPage: 1,
            pageSize: 10,
            totalSize: 0,
            activeIds: [],//当前选中的树形结构数据
            dialogType: '',
            isSort: false,
            map: {},
            attrList: [],
        }
    },
    computed:{
        tableHeader(){
            if(this.activeType === 'category'){
                return [
                    {label: '上级分类', prop: 'pid', },
                    {label: '分类名称', prop: 'name', },
                    {label: '简码', prop: 'code', },
                    {label: '说明及定义', prop: 'explanation', },
                ]
            }else{
                return [
                    {label: '属性', prop: 'name', },
                    {label: '简码', prop: 'code', },
                    {label: '属性值', prop: 'valueArray', align: 'left' },
                ]
            }
        },
        userInfo(){
            return JSON.parse(localStorage.getItem('role'))
        },
    },
    async created(){
        await this.getCategoryList();
        await this.getAttrList(); //获取所有的属性
        this.getTableData();
    },
    methods:{
        // 过滤树
        handleFilter(){
            this.$refs.tree.filter(this.filterText);
        },
        async getAttrList(){
            const params = {
                companyId: this.userInfo.company_id,
            }
            const res = await ajaxPost(Baseurl + '/productCategoryAttribute/selectProductCategoryAttributes', params)
            if(res.data.code === 200){
                this.attrList = res.data.data;
            }else{
                this.attrList = [];
            }
        },
        getTableHeader,
        allowDrop(draggingNode, dropNode, type) {
            // 限制只能放在同层级之间（同一父节点）
            const dragParent = draggingNode.parent;
            const dropParent = dropNode.parent;

            // type 还可以是 'inner'（放到目标节点内部）
            return dragParent === dropParent && type !== 'inner';
        },
        getPeersData(pid){
            if(pid === 0){
                return this.data;
            }
            let isFind = false;
            function getPeersData(data){
                for(let i = 0; i < data.length; i++){
                    if(data[i].id === pid){
                        isFind = true;
                        return data[i]['children'];
                    }
                    if(data[i].children && data[i].children.length > 0){
                        getPeersData(data[i].children);
                    }
                }
                if(!isFind){
                    return [];
                }
            }
            const peersData = getPeersData(this.data);
            return peersData;
        },
        handleDrop(draggingNode, dropNode, dropType, ev) {
            if(this.isSort){
                return;
            }
            this.isSort = true;
            
            const draggingData = draggingNode.data; //拖到的dom
            const dropData = dropNode.data; //目标dom
            // 从小到大的排序
            const pid = dropData.pid;
            const d = this.getPeersData(pid); //同级数据
            const arrs = [];
            for(let i = 0; i < d.length; i++){
                arrs.push({
                    id: d[i].id,
                    sort: i,
                });
            }
            this.$nextTick(()=>{
                ajaxPost(Baseurl + '/productCategory/updateSort', arrs).then(res => {
                    this.isSort = false;
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                })
            })
        },
        handleChange(value){
            
        },
        handleSizeChange(val) {
            this.pageSize = val;
            const total = Math.ceil(this.totalSize / val); //改变页码以后总共有多少页
            // 如果总页面比当前页大,不用赋值,否则赋值为最大值
            this.currentPage = total > this.currentPage ? this.currentPage : total;
            if(this.activeType === 'category'){ 
                this.getTableData();
            }else{
                this.getAttrData();
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            if(this.activeType === 'category'){
                this.getTableData();
            }else{
                this.getAttrData();
            }
        },
        async getCategoryList(){
            this.loadTree = true;
            const params = {
                companyId: this.userInfo.company_id,
            }
            const res = await ajaxPost(Baseurl + '/productCategory/selectProductCategory', params)
            if(res.data.code === 200){
                const result = res.data.data;
                const map = {};
                function sortTreeBySort(arr) {
                    arr.sort((a, b) => a.sort - b.sort); // 先对当前层排序
                    arr.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            sortTreeBySort(item.children); // 递归对子节点排序
                        }
                        map[item.id] = item.name;
                        item['name'] = item.name + ' ' + item.code;
                    });
                }
                sortTreeBySort(result);
                this.data = result;
                this.map = map;
                this.loadTree = false;
            }
        },
        async handleTypeChange(tab, event) {
            this.currentPage = 1;
            this.pageSize = 10;
            this.tableData = [];
            this.totalSize = 0;
            this.activeIds = [];
            this.addForm = {
                name: '',
                pid: [],
                code: '',
                explanation: '',
                valueArray: [],
                attributeIds: [],
            }
            if(tab.name === 'attribute'){
                this.getAttrData();
            }else{
                await this.getCategoryList();
                await this.getAttrList();
                this.getTableData();
            } 
        },
        nodeClick(e, node, data){
            const ids = [e.id];
            let node1 = node;
            while(node1.parent){
                if(node1.parent.data.id){
                    ids.push(node1.parent.data.id);
                }
                node1 = node1.parent;
            }
            ids.reverse();
            this.activeIds = ids; //获取当前激活的id，用于新建时自动选择父级
            this.currentPage = 1;
            this.pageSize = 10;
            this.getTableData();
        },
        handleCreate(){
            if(this.activeType === 'category'){
                // 分类
                let pid = 0;
                if(this.addForm.pid.length > 0){
                    pid = this.addForm.pid[this.addForm.pid.length - 1];
                }
                const keys = [
                    {name: 'name', label: '分类名称'},
                    {name: 'code', label: '分类简码'},
                ]   
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    if(!this.addForm[key.name]){
                        this.$message({
                            type: 'error',
                            message: `${key.label}不能为空`
                        })
                        return;
                    }
                }
                const createData = {
                    pid: pid,
                    name: this.addForm.name,
                    code: this.addForm.code,
                    explanation: this.addForm.explanation,
                    companyId: this.userInfo.company_id,
                    attributeIds: this.addForm.attributeIds,
                }
                let api = '/productCategory/createProductCategory'; //创建
                if(this.addForm.id){
                    api = '/productCategory/updateProductCategory'; //编辑
                    createData.id = this.addForm.id;
                }
                ajaxPost(Baseurl + api, createData).then(async res => {
                    if(res.data.code === 200){
                        await this.getCategoryList();
                        this.getTableData();
                        this.handleClose();
                    }
                })
            }else{
                // 属性
                const createData = {
                    name: this.addForm.name,
                    code: this.addForm.code,
                    valueArray: this.addForm.valueArray,
                    companyId: this.userInfo.company_id,
                }
                if(!this.addForm.name){
                    this.$message({
                        type: 'error',
                        message: '属性名称不能为空'
                    })
                    return;
                }
                if(this.addForm.valueArray.length === 0){
                    this.$message({
                        type: 'error',
                        message: '属性值不能为空'
                    })
                    return;
                }
                const obj = {};
                for(let i = 0; i < this.addForm.valueArray.length; i++){
                    const item = this.addForm.valueArray[i];
                    if(!item.name){
                        this.$message({
                            type: 'error',
                            message: '第' + (i + 1) + '条的属性值名称不能为空'
                        })
                        return;
                    }
                    if(!obj[item.name]){
                        obj[item.name] = 1;
                    }else{
                        obj[item.name]++;
                    }
                }
                for(let k in obj){
                    if(obj[k] > 1){
                        this.$message({
                            type: 'error',
                            message: '属性值 ' + k + ' 不能重复'
                        })
                        return;
                    }
                }
                let api = '/productCategoryAttribute/createProductCategoryAttribute'; //创建
                if(this.addForm.id){
                    api = '/productCategoryAttribute/updateProductCategoryAttribute'; //编辑
                    createData.id = this.addForm.id;
                }
                ajaxPost(Baseurl + api, createData).then(async res => { 
                    if(res.data.code === 200){
                        this.getAttrData();
                        this.handleClose();
                    }
                })
            }
        },
        // 获取属性数据
        getAttrData(){
            this.loadTable = true;
            const params = {
                companyId: this.userInfo.company_id,
                page: this.currentPage,
                size: this.pageSize,
            }
            if(this.attributeText){
                params.searchStr = this.attributeText;
            }
            ajaxPost(Baseurl + '/productCategoryAttribute/selectProductCategoryAttributePage', params).then(res => {
                if(res.data.code === 200){
                    this.tableData = res.data.data.list;
                    this.totalSize = res.data.data.total;
                    this.loadTable = false;
                }
            })
        },
        // 获取分类表格数据
        getTableData(){
            this.loadTable = true;
            const params = {
                "companyId": this.userInfo.company_id,
                "page": this.currentPage,
                "size": this.pageSize
            }
            let pid = 0;
            if(this.activeIds.length > 0){
                pid = this.activeIds[this.activeIds.length - 1];
            }
            params.pid = pid;
            ajaxPost(Baseurl + '/productCategory/selectProductCategoryByPid', params).then((res)=>{
                if(res.data.code === 200){
                    const childrenData = res.data.data.childCategoryPage;
                    const parentData = res.data.data.parentCategory;
                    const result = childrenData.list;
                    if(parentData){
                        result.unshift(parentData);
                    }
                    for(let i = 0; i < result.length; i++){
                        const r = result[i];
                        const id = r.id;
                        const ids = this.activeIds.filter(item => item !== id);
                        result[i].text = ids.map(item => this.map[item]).join(' / ');
                    }
                    this.tableData = result;
                    this.totalSize = childrenData.total;
                    this.loadTable = false;
                }
            })
        },
        addProperty(){
            const arr = this.addForm.valueArray;
            arr.push({
                name: '',
                value: '',
                code: '',
            })
            this.$set(this.addForm, 'valueArray', arr);
        },
        search(){
            this.pageSize = 10;
            this.currentPage = 1;
            this.getAttrData();
        },
        delProperty(index){
            const arr = this.addForm.valueArray;
            arr.splice(index, 1);
            this.$set(this.addForm, 'valueArray', arr);
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        create(){
            this.dialogType = '创建';
            this.$set(this.addForm, 'pid', this.activeIds);
            this.$set(this.addForm, 'valueArray', [{name: '', value: '', code: ''}]);
            this.createDialogVisible = true;
        },
        edit(row){
            const r = JSON.parse(JSON.stringify(row));
            this.dialogType = '编辑';
            const id = r.id;
            const ids = this.activeIds.filter(item => item !== id);
            this.addForm = r;
            if(this.activeType === 'category'){
                this.$set(this.addForm, 'pid', ids);
                this.$set(this.addForm, 'attributeIds', JSON.parse(r.attribute));
            }else{
                this.$set(this.addForm, 'valueArray', JSON.parse(r.value));
            }
            this.createDialogVisible = true;
        },
        del(row){
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                // 转换数据格式
                const deleteData = {
                    id: row.id
                }
                let api = '/productCategory/deleteProductCategory';
                if(this.activeType === 'attribute'){
                    api = '/productCategoryAttribute/deleteProductCategoryAttribute';
                }
                ajaxPost(Baseurl + api, deleteData)
                    .then(async res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            const total = Math.ceil((this.totalSize - 1) / this.pageSize); //改变页码以后总共有多少页
                            // 如果总页面比当前页大,不用赋值,否则赋值为最大值
                            this.currentPage = total > this.currentPage ? this.currentPage : total;
                            if(this.activeType === 'category'){ 
                                await this.getCategoryList();
                                this.getTableData();
                            }else{
                                this.getAttrData();
                            }
                        }else{
                            this.$message({
                                type: "error",
                                message: res.data.data,
                            });
                        }
                    })
                    .finally(() => {
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
            
        },
        handleClose(done){
            this.addForm = {
                name: '',
                pid: [],
                code: '',
                explanation: '',
                valueArray: [],
            }
            this.createDialogVisible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.sortAndAttribute-box{
    height: calc(100vh - 150px);
    .product-type-tabs{
        height: 35px;
    }
    .row{
        margin: 20px 0;
        display: flex;
        height: 30px;
        justify-content: space-between;
        .search-group{
            display: flex;
            align-items: center;
            .el-input{
                width: 200px;
                margin-right: 20px;
            }
        }
    }
    .content{
        height: calc(100% - 105px);
        display: flex;
        
        .tree-box{
            width: 300px;
            height: 100%;
            box-sizing: border-box;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
            margin-right: 20px;
            .el-input{
                width: 100%;
                margin-bottom: 20px;
                height: 30px;
            }
            .el-tree{
                height: calc(100% - 50px);
                overflow-y: auto;
            }
        }
        .table-content{
            max-height: calc(100% - 70px);
            overflow: auto;
            box-sizing: border-box;
            width: 100%
            
        }
        .table-box{ 
            width: calc(100% - 320px);
            .block{
                padding: 20px 0;
                display: flex;
                justify-content: center;
                height: 30px;
            }
        }
    }
    .form-box{
        display: flex;
        flex-wrap: wrap;
        .form-item{
            width: 50%;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .label{
                color: #000;
                width: 90px;
                font-size: 16px;
                .required{
                    color: red;
                }
            }
            .input-box{
                width: calc(100% - 150px);
                .el-select{
                    width: 100%;
                }
                span{
                    color: #2c8dff;
                    cursor: pointer;
                }
                .inputs-item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    .el-input{
                        width: 31%;
                    }
                    .icon{
                        cursor: pointer;
                    }
                }
            }
            &.w100{
                width: 100%;
            }
        }
    }
}
/deep/ .el-table .el-button:hover{
    border: 1px solid #DCDFE6;
}
/deep/ .el-table .red{
    color: #F56C6C;
}


</style>